import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, Validator } from "@angular/forms";
import { AppConstans } from '../appConstants';

/**
 * Kontrola, že je pro neautochtonní neindigenní UJ zadána oblast původu.
 * Technicky má význam pouze pro žádost o POP, kde se jedná o materiál z dovozu (zadává uživatel). V postatních případech se položka plní z DB dle UJ.
**/
@Injectable({
  providedIn: 'root'
})
export class PuvodOblastUjValidator implements Validator {

  private NAN: string = 'NAN';

  validate(control: AbstractControl): ValidationErrors | null {
    let isDovoz = control.parent?.get('pobockaPovereneOsoby')?.value?.kod == AppConstans.popVydalKodMze;
    if (isDovoz) {
      let puvod = control.parent?.get('puvod')?.value;
      if (puvod?.value == this.NAN && (control.value == void 0 || control.value == '')) {
        return { 'puvodUjError': 'Pro neautochtonní neindigenní UJ položka "z oblasti" povinná.' };
      }
    }
    return null;
  }
}
